/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dataset_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This dataset doesn't exist or you don't have access to it. The link may be broken or the dataset may have been removed." |
*
* @param {Dataset_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dataset_not_found_description = /** @type {((inputs?: Dataset_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dataset_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Datensatz existiert nicht oder du hast keinen Zugriff darauf. Der Link ist möglicherweise ungültig oder der Datensatz wurde entfernt.")
	return /** @type {LocalizedString} */ ("This dataset doesn't exist or you don't have access to it. The link may be broken or the dataset may have been removed.")
});